<script setup lang="ts">
const {
  error = undefined,
  sign = undefined,
  display = 'sentence',
} = defineProps<{
  error?: string | string[];
  sign?: string;
  display?: 'single' | 'sentence' | 'list';
}>();

const errors = computed(() => {
  if (!Array.isArray(error)) {
    return error;
  }

  switch (display) {
    case 'single':
      return error.length ? error[0] : '';
    case 'sentence':
      return $sentence(error);
    case 'list':
      return error;
    default:
      return null;
  }
});

const isList = computed(() => Array.isArray(errors.value));
const hasError = computed(() => errors.value);
</script>
<template>
  <div v-if="hasError" class="error-message" role="alert">
    <div class="error-message__border v-messages">
      <div class="error-message__message v-messages__message">
        <template v-if="isList">
          <ul>
            <li v-for="(e, index) in errors" :key="index">
              {{ e }}
            </li>
          </ul>
        </template>
        <template v-else>
          <span v-if="sign" class="error-message__sign">{{ sign }}</span
          >{{ errors }}
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.error-message {
  display: block;
  color: rgb(var(--v-theme-error));

  &__border {
    opacity: 1 !important;
  }

  &__sign {
    margin-right: 5px;
  }

  &__message {
    -webkit-padding-start: 16px;
    padding-inline-start: 16px;
    -webkit-padding-end: 16px;
    padding-inline-end: 16px;
  }

  > ul,
  li {
    font-family: inherit;
    font-size: inherit;
  }

  > ul {
    margin: inherit;
    padding: inherit;
    color: inherit;
  }
}
</style>
